import { Action } from "redux"

export interface Initialize extends Action {
    cancelText: string
    cancelIcon: string
    confirmText: string
    confirmIcon: string
    title: string
}

export const INITIALIZE = "CONFIRMATIONDIALOG_INITIALIZE"
export const initialize = (
    cancelIcon: string,
    cancelText: string,
    confirmIcon: string,
    confirmText: string,
    title: string,
): Initialize => ({
    type: INITIALIZE,
    cancelIcon,
    cancelText,
    confirmIcon,
    confirmText,
    title,
})

export const UPDATE_VISIBILITY = "CONFIRMATIONDIALOG_UPDATE_VISIBILITY"

export interface UpdateVisibility extends Action {
    isVisible: boolean
}

export const updateVisibility = (isVisible: boolean): UpdateVisibility => ({
    type: UPDATE_VISIBILITY,
    isVisible,
})

export const mapDispatchToProps = {
    initialize,
    updateVisibility,
}

export type DispatchProps = typeof mapDispatchToProps
